// extracted by mini-css-extract-plugin
export default {"dashboard":"MySpacePage_dashboard__kovPg","content":"MySpacePage_content__xSIql"};